import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Input from "../../Inputs/Input";
import Search from "../../Search/Search";
import Title from "../../Title/Title";

export default function Print_Document() {
  return (
    <>
      <Row>
        <Col>
          <Title title="الطلبات" />
        </Col>
      </Row>
      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" bg-[#efc5e6] text-black h-[70px] font-bold text-base">
              <tr>
                <td className="px-1">رقم الطلب</td>
                <td className="px-16"> تاريخ الطلب</td>
                <td className="px-16">نوع الطلب</td>
                <td className="px-16">عدد النسخ</td>
                <td className="px-16">طباعة</td>
              </tr>
            </thead>
            <thead className=" bg-[#efc5e6] text-Secondary h-[70px] font-bold text-base border border-white">
              <tr>
                <td className="px-1">
                  <Search placeholder="بحث" className="!w-[80%]" />
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </thead>
            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>0000</td>
                <td>24/2/2025</td>
                <td>كشف علامات</td>
                <td>
                  {" "}
                  <Input
                    type={"number"}
                    placeholder="ادخل عدد النسخ"
                    className="!p-2"
                  />{" "}
                </td>
                <td>
                  {" "}
                  <button className="w-[100px] bg-[#efc5e6] p-2 rounded-2xl">
                    طباعة
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
}
